<template>
    <div class="column">
        <table class="table is-fullwidth is-bordered">
            <thead>
            <tr>
                <th class="narrow"></th>
                <th>Sale Item</th>
                <th>Color</th>
                <th>Cc</th>
                <th>Result</th>
                <th>Commission</th>
                <th>Auction Fee</th>
                <th>Inland</th>
                <th>Discount</th>
                <th>Total</th>
                <th class="narrow"></th>
            </tr>
            </thead>
            <tbody>
            <proforma-invoice-sales-table-row v-for="(item, index) in items" :item="item" :index="index"></proforma-invoice-sales-table-row>
            <proforma-invoice-sales-table-create-row></proforma-invoice-sales-table-create-row>
            </tbody>
        </table>
    </div>
</template>

<script>
    import ProformaInvoiceSalesTableRow from './ProformaInvoiceSalesTableRow'
    import ProformaInvoiceSalesTableCreateRow from './ProformaInvoiceSalesTableCreateRow'
    export default {
        props:['car'],
        components: {
            ProformaInvoiceSalesTableRow,
            ProformaInvoiceSalesTableCreateRow
        },
        computed: {
            items() {
                return this.$store.getters.getProformaInvoiceSaleItems
            }
        }
    }
</script>

<style scoped>
    th {
        font-size: small;
    }
    .narrow {
        width: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceSalesTable.vue